export const NAME_BASIN_SUMMARY_ITEM = {
  type: 'key',
  label: 'Basin Name',
  accessor: 'name',
};
